var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAdDisableIcon16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m3.739 6.89-1.111 3.158h3l-.684-2.01 2.169 2.067 1.126 3.201H6.727l-.638-1.885H2.143l-.662 1.885H.005L2.69 5.891l1.048.998Zm6.733 6.416h-1.97V11.43l1.97 1.877Zm1.208-8.8c.835 0 1.58.187 2.234.562a4.008 4.008 0 0 1 1.535 1.56c.37.666.556 1.423.556 2.272 0 .849-.186 1.61-.556 2.284a4.008 4.008 0 0 1-1.535 1.56c-.272.156-.56.277-.862.368l-1.242-1.183c.506-.018.955-.14 1.347-.37a2.625 2.625 0 0 0 1.005-1.073c.244-.466.366-.995.366-1.586 0-.59-.122-1.115-.366-1.572a2.544 2.544 0 0 0-1.005-1.062c-.425-.258-.918-.387-1.477-.387H9.92v4.248l-1.417-1.35v-4.27h3.177Zm-5.97 1.61L4.02 4.506h1.123l.566 1.61Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.6,
  d: "m3.2 3.707 11.2 10.4"
})));
export { SvgAdDisableIcon16 as ReactComponent };